import { MapIcon, SearchIcon, TrendingUpIcon, ClipboardCheckIcon, MessageCircleIcon, CalendarIcon } from 'lucide-react';

export const bonuses = [
  {
    icon: MapIcon,
    emoji: '🗺️',
    title: 'Mapa Rápido para Armar Clases en 10 Minutos',
    value: '19€',
    text: 'Una herramienta para agilizar la preparación de tu próxima clase: elige la intención, sigue la pauta de selección y ajusta la plantilla a tu grupo.',
    items: ['5 intenciones de clase', 'Pauta de selección de ejercicios', 'Plantilla imprimible', '3 clases adicionales organizadas por bloques']
  },
  {
    icon: SearchIcon,
    emoji: '🔍',
    title: 'Selector de Ejercicios por Objetivo y Nivel',
    value: '19€',
    text: 'Índice de las 240 fichas con objetivo, material, ruta de dificultad, código y página, más ejemplos de búsqueda.',
    items: ['Objetivo, material y código por ficha', 'Ruta de dificultad y número de página', 'Ejemplos de búsqueda guiada', 'PDF consultable en computadora o dispositivo móvil']
  },
  {
    icon: TrendingUpIcon,
    emoji: '📈',
    title: 'Guía de Progresiones y Regresiones',
    value: '19€',
    text: 'Cinco herramientas de adaptación y diez casos prácticos para decidir qué reducir, qué cambiar y qué observar antes de avanzar.',
    items: ['5 herramientas de adaptación', '10 casos prácticos', 'Qué reducir y qué cambiar', 'Qué observar antes de avanzar']
  },
  {
    icon: ClipboardCheckIcon,
    emoji: '✅',
    title: 'Checklist de Correcciones Profesionales',
    value: '19€',
    text: 'Diez patrones de error, 35 frases de corrección y una hoja imprimible de seguimiento.',
    items: ['10 patrones de error habituales', '35 frases de corrección', 'Hoja imprimible de seguimiento', 'Qué observar en cada sesión']
  },
  {
    icon: MessageCircleIcon,
    emoji: '💬',
    title: 'Guiones de Cues Profesionales',
    value: '19€',
    text: '60 consignas organizadas en diez áreas, cinco aperturas y cinco cierres de clase, con pautas para construir tus propias indicaciones.',
    items: ['60 consignas en 10 áreas', '5 guiones de apertura', '5 guiones de cierre', 'Pautas para crear tus propias consignas']
  },
  {
    icon: CalendarIcon,
    emoji: '📅',
    title: 'Planificador de Clases y Rotación de Repertorio',
    value: '19€',
    text: 'Ciclo de cinco semanas, mapa orientativo de 40 semanas y plantillas de planificación grupal, individual y rotación del repertorio.',
    items: ['Ciclo de 5 semanas', 'Mapa orientativo de 40 semanas', 'Plantillas grupal e individual', 'Qué mantener, repetir y variar']
  }
];
